export default __webpack_public_path__ + "static/media/steps-cover-8-3.55eafe80.png";